import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// ====== Import schemas from generated ======
const {
  ProductUnitFirestoreResponse,
  CreateProductUnitDto,
  UpdateProductUnitDto,
  DeleteProductUnitResponseDto,
} = schemas;

// ====== Re-export schemas for external use ======
export const ProductUnitResponseSchema = ProductUnitFirestoreResponse;
export const CreateProductUnitSchema = CreateProductUnitDto;
export const UpdateProductUnitSchema = UpdateProductUnitDto;
export const DeleteResponseSchema = DeleteProductUnitResponseDto;

// Type exports
export type ProductUnitResponse = z.infer<typeof ProductUnitFirestoreResponse>;
export type CreateProductUnit = z.infer<typeof CreateProductUnitDto>;
export type UpdateProductUnit = z.infer<typeof UpdateProductUnitDto>;

// API factory function
export function createProductUnitsApi(client: TypedApiClient) {
  return {
    getProductUnits: (): Promise<ProductUnitResponse[]> => {
      return client.get('/product-units', {
        responseSchema: z.array(ProductUnitResponseSchema),
      });
    },

    createProductUnit: (data: CreateProductUnit): Promise<ProductUnitResponse> => {
      CreateProductUnitSchema.parse(data);
      return client.post('/product-units', {
        data,
        responseSchema: ProductUnitResponseSchema,
      });
    },

    updateProductUnit: (id: string, data: UpdateProductUnit): Promise<ProductUnitResponse> => {
      return client.patch(apiPath`/product-units/${id}`, {
        data,
        responseSchema: ProductUnitResponseSchema,
      });
    },

    deleteProductUnit: (id: string): Promise<z.infer<typeof DeleteResponseSchema>> => {
      return client.delete(apiPath`/product-units/${id}`, {
        responseSchema: DeleteResponseSchema,
      });
    },
  };
}
